export const leadsMock = [];

export const statusLeadOpcoes = [
  "Aguardando",
  "Aprovado",
  "Sem Retorno",
];

export const servicosOpcoes = [
  "Contabilidade",
  "Departamento Pessoal",
  "Abertura de Empresa",
  "Alteração Contratual",
  "Consultoria Financeira",
  "Administração de Condomínio",
  "Consultoria Tributária",
  "Outros",
];
